import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const pageNames: Record<string, string> = {
  '/': 'หน้าหลัก',
  '/dashboard': 'หน้าหลัก',
  '/payment': 'ชำระค่าเรียน',
  '/lessons': 'บทเรียน',
  '/expenses': 'ค่าใช้จ่าย',
  '/profile': 'โปรไฟล์',
  '/admin/dashboard': 'แดชบอร์ดผู้ดูแล',
  '/login': 'เข้าสู่ระบบ'
}

export const NavigationAnnouncer: React.FC = () => {
  const [announcement, setAnnouncement] = useState('')
  const location = useLocation()
  
  useEffect(() => {
    const pageName = pageNames[location.pathname] || 'หน้าไม่ทราบ'
    setAnnouncement(`นำทางไปยัง ${pageName}`)
    
    // Clear announcement after screen reader reads it
    const timeout = setTimeout(() => {
      setAnnouncement('')
    }, 1000)
    
    return () => clearTimeout(timeout)
  }, [location.pathname])
  
  return (
    <div 
      aria-live="polite" 
      aria-atomic="true"
      className="sr-only"
    >
      {announcement}
    </div>
  )
}